// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
body {
  background-color: var(--background);
  font-family: "Roboto", sans-serif;
}

h1 {
  text-align: center;
}

.accordion {
  width: 50%;
  margin: 90px auto;
  color: var(--text-color);
  background-color: var(--background);
  padding: 45px 45px;
}

.accordion .container {
  position: relative;
  margin: 10px 10px;
}

.accordion .label {
  position: relative;
  padding: 10px 0;
  font-size: 1.4rem;
  color: var(--text-color);
  cursor: pointer;
}

.accordion .label::before {
  content: "▼";
  color: var(--text-color);
  position: absolute;
  top: 50%;
  right: -5px;
  font-size: 20px;
  transform: translateY(-50%);
  text-shadow: 2px 2px 4px rgba(197, 188, 188, 0.5);
}

.accordion .content {
  position: relative;
  background: var(--background);
  max-height: 0;
  font-size: 1rem;
  width: 95%;
  overflow: hidden;
  transition: max-height 0.5s cubic-bezier(0, 1, 0, 1); /* Smooth opening transition */
  padding-left: 0px;
  transform: translateY(10%);
  text-align: justify;
}

.accordion .container.active .content {
  max-height: 9999px; /* Very high max-height for smooth transition */
  transition: max-height 0.5s cubic-bezier(1, 0, 1, 0); /* Smooth closing transition */
}

.accordion hr {
  width: 100%;
  margin-left: 0;
  border: 1px solid;
}

.accordion .container.active .label::before {
  content: "▲";
  font-size: 20px;
}

li {
  margin-top: 15px;
}

@media only screen and (max-width: 960px) {
  .accordion {
    width: 55%;
  }
  .accordion .label {
    font-size: 1.2rem;
  }
}
@media only screen and (max-width: 926px) {
  .accordion {
    width: 60%;
  }
  .accordion .content {
    margin-bottom: 5px;
  }
}
@media only screen and (max-width: 904px) {
  .accordion {
    width: 65%;
  }
}
@media only screen and (max-width: 700px) {
  .accordion {
    width: 65%;
  }
  .accordion .label {
    font-size: 1rem;
  }
  .accordion .content {
    margin-bottom: 15px;
  }
}
@media only screen and (max-width: 603px) {
  .accordion {
    width: 70%;
  }
  .accordion .content {
    margin-bottom: 15px;
  }
}
@media only screen and (max-width: 546px) {
  .accordion {
    width: 75%;
  }
  .accordion .content {
    margin-bottom: 15px;
  }
}
@media only screen and (max-width: 520px) {
  .accordion {
    width: 70%;
    padding: 30px 30px;
  }
  .accordion .content {
    margin-bottom: 15px;
  }
}
@media only screen and (max-width: 475px) {
  .accordion .content {
    margin-bottom: 35px;
  }
}
@media only screen and (max-width: 380px) {
  .accordion {
    width: 90%;
    padding: 20px 20px;
  }
}
@media only screen and (max-width: 280px) {
  .accordion {
    width: 90%;
    padding: 10px 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/faq/faq.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,mCAAA;EACA,iCAAA;AAEF;;AACA;EACE,kBAAA;AAEF;;AACA;EACE,UAAA;EACA,iBAAA;EACA,wBAAA;EACA,mCAAA;EACA,kBAAA;AAEF;;AACA;EACE,kBAAA;EACA,iBAAA;AAEF;;AACA;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,eAAA;AAEF;;AACA;EACE,YAAA;EACA,wBAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;EACA,2BAAA;EACA,iDAAA;AAEF;;AAEA;EACE,kBAAA;EACA,6BAAA;EACA,aAAA;EACA,eAAA;EACA,UAAA;EACA,gBAAA;EACA,oDAAA,EAAA,8BAAA;EACA,iBAAA;EACA,0BAAA;EACA,mBAAA;AACF;;AAEC;EACC,kBAAA,EAAA,+CAAA;EACA,oDAAA,EAAA,8BAAA;AACF;;AAcA;EACE,WAAA;EACA,cAAA;EACA,iBAAA;AAXF;;AAcA;EACE,YAAA;EACA,eAAA;AAXF;;AAcA;EACE,gBAAA;AAXF;;AAcA;EACE;IACE,UAAA;EAXF;EAcA;IACE,iBAAA;EAZF;AACF;AAeA;EACE;IACE,UAAA;EAbF;EAgBA;IACE,kBAAA;EAdF;AACF;AAiBA;EACE;IACE,UAAA;EAfF;AACF;AAkBA;EACE;IACE,UAAA;EAhBF;EAmBA;IACE,eAAA;EAjBF;EAoBA;IACE,mBAAA;EAlBF;AACF;AAqBA;EACE;IACE,UAAA;EAnBF;EAsBA;IACE,mBAAA;EApBF;AACF;AAuBA;EACE;IACE,UAAA;EArBF;EAwBA;IACE,mBAAA;EAtBF;AACF;AAyBA;EACE;IACE,UAAA;IACA,kBAAA;EAvBF;EA0BA;IACE,mBAAA;EAxBF;AACF;AA2BA;EAEE;IACE,mBAAA;EA1BF;AACF;AA6BA;EACE;IACE,UAAA;IACA,kBAAA;EA3BF;AACF;AA8BA;EACE;IACE,UAAA;IACA,kBAAA;EA5BF;AACF","sourcesContent":["body{\r\n  background-color: var(--background);\r\n  font-family: 'Roboto', sans-serif;\r\n}\r\n\r\nh1{\r\n  text-align: center;\r\n}\r\n\r\n.accordion{\r\n  width: 50%;\r\n  margin: 90px auto;\r\n  color: var(--text-color);\r\n  background-color: var(--background);\r\n  padding: 45px 45px;\r\n}\r\n\r\n.accordion .container{\r\n  position: relative;\r\n  margin: 10px 10px;\r\n}\r\n\r\n.accordion .label{\r\n  position: relative;\r\n  padding: 10px 0;\r\n  font-size: 1.4rem;\r\n  color: var(--text-color);\r\n  cursor: pointer;\r\n}\r\n\r\n.accordion .label::before{\r\n  content: '\\25BC';\r\n  color: var(--text-color);\r\n  position: absolute;\r\n  top: 50%;\r\n  right: -5px;\r\n  font-size: 20px;\r\n  transform: translateY(-50%);\r\n  text-shadow: 2px 2px 4px rgba(197, 188, 188, 0.5);\r\n}\r\n\r\n\r\n.accordion .content {\r\n  position: relative;\r\n  background: var(--background);\r\n  max-height: 0;\r\n  font-size: 1rem;\r\n  width: 95%;\r\n  overflow: hidden;\r\n  transition: max-height 0.5s cubic-bezier(0,1,0,1); /* Smooth opening transition */\r\n  padding-left: 0px;\r\n  transform: translateY(10%);\r\n  text-align: justify;\r\n }\r\n \r\n .accordion .container.active .content {\r\n  max-height: 9999px; /* Very high max-height for smooth transition */\r\n  transition: max-height 0.5s cubic-bezier(1,0,1,0); /* Smooth closing transition */\r\n }\r\n \r\n\r\n// .accordion .container.active .block{\r\n//   content: \"\";\r\n//   position: absolute;\r\n//   width: .6rem;\r\n//   height: 60%;\r\n//   background-color: #8FC3F2;\r\n//   top: 55%;\r\n//   left: 0;\r\n//   transform: translateY(-40%);\r\n// }\r\n\r\n.accordion hr{\r\n  width: 100%;\r\n  margin-left: 0;\r\n  border: 1px solid;\r\n}\r\n\r\n.accordion .container.active .label::before{\r\n  content: '\\25B2';\r\n  font-size: 20px;\r\n}\r\n\r\nli {\r\n  margin-top: 15px;\r\n}\r\n\r\n@media only screen and (max-width:960px){\r\n  .accordion{\r\n    width: 55%;\r\n  }\r\n\r\n  .accordion .label{\r\n    font-size: 1.2rem;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width:926px){\r\n  .accordion{\r\n    width: 60%;\r\n  }\r\n\r\n  .accordion .content{\r\n    margin-bottom: 5px;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width:904px){\r\n  .accordion{\r\n    width: 65%;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width:700px){\r\n  .accordion{\r\n    width: 65%;\r\n  }\r\n\r\n  .accordion .label{\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .accordion .content{\r\n    margin-bottom: 15px;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width:603px){\r\n  .accordion{\r\n    width: 70%;\r\n  }\r\n\r\n  .accordion .content{\r\n    margin-bottom: 15px;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width:546px){\r\n  .accordion{\r\n    width: 75%;\r\n  }\r\n\r\n  .accordion .content{\r\n    margin-bottom: 15px;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width:520px){\r\n  .accordion{\r\n    width: 70%;\r\n    padding: 30px 30px;\r\n  }\r\n\r\n  .accordion .content{\r\n    margin-bottom: 15px;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width:475px){\r\n\r\n  .accordion .content{\r\n    margin-bottom: 35px;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width:380px){\r\n  .accordion{\r\n    width: 90%;\r\n    padding: 20px 20px;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width:280px){\r\n  .accordion{\r\n    width: 90%;\r\n    padding: 10px 10px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
